/**
 * ACL 权限代码常量（与 nest-api resource:action 格式对齐）
 */

/** 超级管理员通配权限 */
export const ALL_MANAGE_PERMISSION = 'all:manage';

/** 资产模块权限 */
export const ASSET_PERMISSION = {
  LIST: 'asset:list',
  READ: 'asset:read',
  CREATE: 'asset:create',
  UPDATE: 'asset:update',
  DELETE: 'asset:delete',
  IMPORT: 'asset:import',
  TRANSFER: 'asset:transfer',
  MANAGE: 'asset:manage',
} as const;

/** 订单模块权限 */
export const ORDER_PERMISSION = {
  READ: 'order:read', // 查看订单
  CREATE: 'order:create', // 创建订单
  UPDATE: 'order:update', // 更新订单
  DELETE: 'order:delete', // 删除订单
  COMPLETE: 'order:complete', // 完成订单
  CANCEL: 'order:cancel', // 取消订单
  ASSET: 'order:order_asset_management', // 绑定资产
  AMOUNT_MANAGEMENT: 'order:order_amount_management', // 资金管理
  LOG: 'order:order_log', // 查看订单日志
} as const;

/** 财务模块权限 */
export const FINANCE_PERMISSION = {
  LIST: 'finance:list',
  READ: 'finance:read',
  CREATE: 'finance:create',
  UPDATE: 'finance:update',
  DELETE: 'finance:delete',
} as const;

/** 组织、角色权限管理 */
export const STAFF_PERMISSION = {
  LIST: 'staff:list',
  MANAGE: 'staff:manage',
} as const;

/** 商品模块权限 */
export const PRODUCT_PERMISSION = {
  LIST: 'product:list',
  CREATE: 'product:create',
  UPDATE: 'product:update',
  DELETE: 'product:delete',
  MANAGE: 'product:manage',
} as const;
